export const limitsChange = {
    showInfoMessage: true,
    validations: {
        relyOnMaximumTemporaryLimitForTemporaryLimitValidation: true,
    },
};
